import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { AppInsightsService } from '../shared/services/appinsights/appinsights.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '../shared/templates/Locale/locales.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LocaleComponent } from '../shared/templates/Locale/locale.component';

@Component({
  selector: 'app-default-error-page',
  templateUrl: './default-error-page.component.html'
})
export class DefaultErrorPageComponent implements OnInit {
  @ViewChildren(LocaleComponent) localeComponents: QueryList<LocaleComponent>;

  private ngUnsubscribe$: Subject<boolean> = new Subject();

  constructor(private route: ActivatedRoute, private appInsightsService: AppInsightsService,
    private configService: ConfigService, private router: Router) { }

  ngOnInit() {
    this.appInsightsService.logPageView('GenericErrorComponent');
    this.route.params
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(params => {
        this.configService.languagerequested = params['lang'];
        if (this.localeComponents) {
          this.localeComponents.forEach(comp => comp.setLocale());
        }
      });
  }

  goBackToStart(): void {
    let action = this.configService.iframeAction || 'all';
    this.router.navigateByUrl(`customer/${action}/${this.configService.languagerequested}`);
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

}
